/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { AgreementApiModel } from '../../models/DealModel';

export interface HomeDeal {
  homeDealId: string;
  homeDeal: AgreementApiModel;
}

const initialState: HomeDeal = {
  homeDealId: localStorage.getItem('selectedHomeDealId') || '',
  homeDeal: null,
};

export const selectedHomeDealSlice = createSlice({
  name: 'selectedHomeDeal',
  initialState,
  reducers: {
    setHomeDeal: (state, { payload }: { payload: AgreementApiModel }) => {
      localStorage.setItem('selectedHomeDealId', payload.id);
      state.homeDealId = payload.id;
      state.homeDeal = payload;
    },
    resetHomeDeal: () => {
      localStorage.removeItem('selectedHomeDealId');
      return initialState;
    },
  },
  extraReducers: () => {},
});
export const { setHomeDeal, resetHomeDeal } = selectedHomeDealSlice.actions;
export const selectedHomeDealSelector = (state: RootState) =>
  state.selectedHomeDeal;
